import { Section, ChromeHeading, GoldText, PulseCTA, Badge } from "../funnel";
import { EVENT_DAY_LABEL } from "../../config/event";

export const FinalCTA = () => (
  <Section className="overflow-hidden" data-testid="final-cta-section">
    <div className="breathe-glow pointer-events-none absolute left-1/2 top-1/2 h-[520px] w-[min(900px,130vw)] -translate-x-1/2 -translate-y-1/2" aria-hidden="true" />
    <div className="relative mx-auto flex max-w-4xl flex-col items-center text-center">
      <Badge size={120} className="rounded-xl" />
      <ChromeHeading className="mt-8 text-4xl sm:text-5xl lg:text-6xl" data-testid="final-cta-headline">
        On {EVENT_DAY_LABEL} I break the whole process down. <GoldText>Bring your hardest questions.</GoldText>
      </ChromeHeading>
      <PulseCTA className="mt-10 w-full sm:w-auto" data-testid="final-cta-button" />
      <p className="font-mono-plex mt-5 text-[11px] uppercase tracking-[0.25em] text-[#a59f93]">Free · Live · No credit pull</p>
    </div>
  </Section>
);
